import React from 'react';
import MyTableCell from './MyTableCell';
import { styleCellTitle } from '../../bonus/ui/styles';

/**
 * @component
 * @param {Object} props - Свойства компонента
 * @param {React.ReactNode} props.children - Содержимое ячейки
 * @param {boolean} [props.isLess] - Уменьшить отступы (приоритет над isSmall)
 * @param {boolean} [props.isSmall] - Маленькие отступы
 * @param {'text' | 'numeric'} [props.type] - Тип ячейки
 * @param {Object} [props.sx] - Дополнительные MUI стили
 * @returns {JSX.Element} Ячейка таблицы с адаптивными отступами
 *
 */
export default function MyTableBoldCell({ children, isLess, ...props }) {
  return (
    <MyTableCell style={styleCellTitle} isLess={isLess} {...props}>
      {children}
    </MyTableCell>
  );
}
